import { render, staticRenderFns } from "./TaskUpdateAfterWork.vue?vue&type=template&id=e1701078&"
import script from "./TaskUpdateAfterWork.vue?vue&type=script&lang=js&"
export * from "./TaskUpdateAfterWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports